import { CellPlugin } from '@react-page/editor';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CurrencyFormatter } from '../../../../components/Formatters';

// use a type here, not an interface
type Data = {
  label: string,
  tag: string,
  value: any
}

const getValue = (value: any) => {
  if (value) {
    return value?.orderTransaction?.orderSummary?.convenienceFeeIsClientAbsorbed ? '0' : value?.convenienceFee;
  } else {
    return "1.00";
  }
}

const ConvenienceFeePropertyPlugin: CellPlugin<Data> = {
  Renderer: ({ data }) => (
      <Row>
        <Col><strong>{data.label}</strong></Col>
        <Col>{CurrencyFormatter(getValue(data.value))}</Col>
      </Row>
  ),
  id: 'convenienceFeePropertyPlugin',
  title: 'Convenience Fee Property',
  description: 'Convenience Fee Property.',
  version: 1,
  controls: {
    type: 'autoform',
    schema: {
      properties: {
        label: {
          type: 'string',
          default: 'Convenience Fee',
            },
        tag: {
            type: 'string',
            default: 'Convenience Fee',
            readOnly: true
        },
      },
      required: ['label'],
    },
  },
};

export default ConvenienceFeePropertyPlugin;